import React from 'react';
import { observer, inject } from 'mobx-react';

import CommonButton from '~/common/components/CommonButton';

import BoxWrapper from '~/common/components/BoxWrapper';
import LoadingSpinner from '~/common/components/LoadingSpinner';
import AccountInfo from '~/views/Billing/components/AccountInfo';
import BillingInfo from '~/views/Billing/components/BillingInfo';
import PaymentInfo from '~/views/Billing/components/PaymentInfo';

import Tracking from '~/common/utils/gaTracking';
import { mapEcommerceItems } from '~/common/utils/trackingHelpers';

import OrderSummary from '../OrderSummary';

// Import Stylesheet
import styles from './checkout.css';

@inject('checkoutStore', 'formsStore', 'flexFrameStore', 'contentStore')
@observer
export default class Checkout extends React.Component {
    constructor(props) {
        super(props);
        this.tracking = new Tracking();

        this.tracking.trackBeginCheckout({
            step: 2,
            ecommerce: mapEcommerceItems({
                selectedPlan: props.checkoutStore.selectedPlan,
                billingPeriod: props.formsStore.BillingPeriod,
                currencyCode: props.contentStore.contentData.CurrencyCode,
                licenseSelector: props.formsStore.LicenseSelector,
                selectedAddons: props.checkoutStore.selectedAddons
            })
        });
    }

    formSubmit = (e) => {
        e.preventDefault();
        if (!this.props.checkoutStore.submitting) {
            this.props.checkoutStore.formSubmit();
        }
    };

    gotoError = () => {
        const top = document.getElementsByClassName('input__error')[0];
        top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    };

    render() {
        const { labelContent } = this.props.contentStore;
        const { formError, submitting, isUpgradeFlow, brand } = this.props.checkoutStore;
        const { FirstName, LastName, Email } = this.props.formsStore;
        const WelcomeUser = labelContent.WelcomeUser.replace('{FullName}', ``);

        return (
            <div className="checkout">
                {formError &&
                <div className={styles['error-box']}>
                    <span dangerouslySetInnerHTML={{ __html: labelContent.ErrorSummaryMessage }} />
                    <a onClick={() => this.gotoError()}>{labelContent.ShowMe}</a>
                </div>
                }
                {isUpgradeFlow ?
                    <>
                      <h2>{WelcomeUser}</h2>
                      <p>{`${FirstName} ${LastName}`}<br/>{`${Email}`}</p>
                    </> :
                    <BoxWrapper>
                        <AccountInfo />
                    </BoxWrapper>
                }
                <BoxWrapper>
                    <BillingInfo />
                </BoxWrapper>
                <BoxWrapper>
                    <PaymentInfo />
                </BoxWrapper>
                <OrderSummary mobile={true} />
                <CommonButton
                    brand={brand}
                    data-button='checkout-proceed'
                    modifier={submitting ? 'common-button__proceed common-button__proceed--submitting' : 'common-button__proceed'}
                    onClick={e => this.formSubmit(e)}
                >{submitting ?
                        <LoadingSpinner className={'loadingSpinner__small'} /> : labelContent.CompletePayment}</CommonButton>
            </div>
        );
    }
}
